export const getRequiredValueValidationMsg = (label) => [label, "is mandatory"];
export const getValidationErrorMessage = (label) => [label, "is invalid"];
